<template>
  <div class="delivery-info">
    <div class="title">運費</div>
    <div class="mt-2">
      <ol>
        <li>
          我們與多家專業物流公司配合為您提供安全可靠的宅配服務,商品的運送範圍台灣本島內不加收額外運費;
          特殊大型家具、外島及海外地區將加收額外運費,請您於訂購前與我們連絡,我們將依您所在地區及商品屬性為您規劃較佳的運送方式及提供運費報價。
        </li>
        <li>
          運送商品過程當中,倘若無法依一般運送方式,額外需求起重機、玻璃拆卸、樓梯搬運、或任何特殊問題等,
          都可能另外收取特殊運送費用。如果您無法確定是否須加收特殊運送費用,請您於訂購前與我們連絡,我們將依商品及運送地點為您詳細評估並提供報價。
        </li>
      </ol>
    </div>
    <div class="title mt-3">運送時間</div>
    <div class="mt-2">
      <ol>
        <li>
          現貨商品:我們在確認收到您的款項後,將於下一個工作天為您處理出貨,約需2-5 工作天送達您指定的收貨地址。
        </li>
        <li>
          期貨商品:依商品頁面上標示之預估到貨時間,包含原廠製作商品時程、運送時間以及海關清關/檢驗時間等,由於程序複雜,
          如偶有無法於預定時間到貨或商品改款、缺貨,我們將於第一時間以電話/電子郵件通知您詳細狀況。
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeliveryInfo'
}
</script>

<style scoped>
.title {
  font-size: 1.2rem;
  font-weight: 700;
  font-family: 'Noto Serif TC', serif;
}
img {
  height: 50px;
}
</style>
